import type { ActivityLogRow } from '@/data/types';

export function getSocialShopSourceLabel(row: ActivityLogRow): string | null {
  if (!row.isFromSocialShop) {
    return null;
  }

  if (row.isSocialShopOwnerShared) {
    return row.socialShopName ? `via ${row.socialShopName}` : 'via a shop';
  }

  return "via a member's shop";
}

export function getSocialShopProfilePath(row: ActivityLogRow): string | null {
  if (!row.isFromSocialShop || !row.isSocialShopOwnerShared || !row.socialShopEntityId) {
    return null;
  }

  if (row.socialShopEntity === 'Organization') {
    return `/web/profile/organization/${row.socialShopEntityId}`;
  }

  if (row.socialShopEntity === 'User') {
    return `/web/profile/user/${row.socialShopEntityId}`;
  }

  return null;
}

export function formatSocialShopSourceForExport(row: ActivityLogRow): string {
  return getSocialShopSourceLabel(row) ?? '';
}
